import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { KeyProjectsComponent } from './key-projects/key-projects.component';
import { PartnerComponent } from './partner/partner.component';
import { ServicesComponent } from './services/services.component';

const routes: Routes = [
  {
    path:'', component: HomeComponent
  },
  {
    path:'about', component: AboutComponent
  },
  {
    path:'contact', component: ContactComponent
  },
  {
    path:'key-projects', component: KeyProjectsComponent
  },
  {
    path:'partner', component: PartnerComponent
  },
  {
    path:'services', component: ServicesComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
